<template>
    <ion-page>
        <standard-header title="Stock Takes" align="middle"/>
        <ion-content :fullscreen="true">
            <pull-down-refresh :callback="refresh" />
            <skeleton :rows="4" v-if="stocktakes === null"/>
            <sub-title v-if="stocktakes !== null" :count="stocktakes?stocktakes.length:null">My Stock Takes</sub-title>
            <div v-show="stocktakes && stocktakes.length < 1">
                <no-results title="No Results">
                    No stock takes have been assigned to you
                </no-results>
            </div>
            <div v-if="stocktakes !== null">
                <ion-list>
                    <div v-for="take in stocktakes" :key="take.id">
                      <ion-item button detail @click="goToTake(take)" lines="none">
                        <pick-list-item :stocktake="take" :completed="take.has_concluded" />
                        <shipment-membership-tools
                            ref="members"
                            :users="take.users"
                            type="stocktakes"
                            name="Stock Take"
                            :job="take"
                            @updated="refresh()"
                        />
                      </ion-item>
                      <ion-progress-bar :value="take.pc_complete/100"/>
                    </div>
                </ion-list>
            </div>
        </ion-content>
    </ion-page>
</template>

<script>
import {IonContent, IonItem, IonList, IonPage, IonProgressBar} from '@ionic/vue';
import StandardHeader from "@/components/StandardHeader.vue";
import {alertController} from '@ionic/vue';

import SubTitle from "@/components/SubTitle";
import NoResults from "@/components/NoResults";
import EventBus from '@/EventBus';
import Skeleton from "@/components/Skeleton";
import PullDownRefresh from "@/components/PullDownRefresh";
import ShipmentMembershipTools from "@/components/ShipmentMembershipTools";
import _ from 'lodash';
import PickListItem from "@/views/modules/picking/components/PickListItem";
export default {
    inject: ['$http'],
    name: 'MyStockTakesList',
    components: {
        PickListItem,
        ShipmentMembershipTools, PullDownRefresh,
        Skeleton,
        NoResults, SubTitle, StandardHeader,
        IonContent, IonPage, IonItem, IonList, IonProgressBar
    },
    data() {
        return {
            stocktakes: null,
        }
    },
    created() {
        EventBus().emitter.on('stocktakes.index.refresh', () => {
            this.refresh();
        }, this);
    },
    methods: {
        goToTake(take) {
            if (this.$refs.members.hasAcceptedMembership(take.users)) {
                this.$router.push({name: 'stocktakes.stocktake.lines', params: {id: take.id}});
            } else {
                alertController.create({
                    message: 'You have not yet accepted this stock take',
                    buttons: ['Ok']
                }).then(alert => alert.present());
            }
        },
        ionViewDidEnter() {
            this.refresh();
        },
        refresh(event = null) {
            EventBus().emitter.emit('loading', true);
            this.$http.get('/api/stocktakes/me/stocktakes', {
                params: {include: 'users', state: 'active', all: true}
            }).then(response => {
                this.stocktakes = response.data.items;  
                this.stocktakes = _.sortBy(this.stocktakes, ['priority.id']).reverse();
            }).finally(() => {
                if (event && event.target.complete) {
                    event.target.complete();
                }
                EventBus().emitter.emit('loading', false);
            });
        }
    }
}
</script>

